<template>
  <div id='map-test'></div>
</template>

<script>
  import 'ol/ol.css';

  import OSM from 'ol/source/OSM';
  import TileLayer from 'ol/layer/Tile';
  import {Map, View} from 'ol';
  import {fromLonLat} from 'ol/proj';
  import GeoJSON from 'ol/format/GeoJSON';
  import VectorSource from 'ol/source/Vector';

  export default {
    name: 'MapTest',

    props: { abrisPoints: Array },

    data: () => ({
      map: null,
    }),

    methods: {
      createMap() {
        this.map = new Map({
          target: 'map-test',
          layers: [
            new TileLayer({
              source: new OSM()
            })
          ],
          view: new View({
            center: fromLonLat([0, 0]),
            zoom: 2
          })
        });

      },

      createVectorLayer() {
        const coordinates = [[]];
        const center = [ 0, 0 ];

        this.abrisPoints.forEach(point => {
          const temp = [];
          temp[0] = point.lon;
          temp[1] = point.lat;

          coordinates[0].push(temp);
        });

        const features = [];
        features.push({
          'type': 'Feature',
          'geometry': {
            'type': 'Polygon',
            'coordinates': coordinates
          }
        });

        const geojsonObject = {
          'type': 'FeatureCollection',
          'crs': {
            'type': 'name',
            'properties': {
              'name': 'EPSG:3857'
            } 
          },
          'features': features
        };

        const vectorSource = new VectorSource({
          features: (new GeoJSON()).readFeatures(geojsonObject)
        });
      }
    },

    mounted() {
 
      this.createMap();
      
    }

  };
</script>

<style scoped>

  #map-test {
    height: 400px;
    width: 400px;
  }

</style>
